import { addMonths, format, subMonths } from 'date-fns'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

const useDateRange = () => {
  const location = useLocation()

  const defaultStart = format(subMonths(new Date(), 1), 'yyyy-MM-dd')
  const defaultEnd = format(addMonths(new Date(), 1), 'yyyy-MM-dd')
  const [range, setRange] = useState([defaultStart, defaultEnd])

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const startDateParam = searchParams.get('start_delivery_date')
    const endDateParam = searchParams.get('end_delivery_date')

    setRange([startDateParam || defaultStart, endDateParam || defaultEnd])
  }, [location])

  return range
}

export default useDateRange
